// extracted by mini-css-extract-plugin
module.exports = {"editinfoBlock":"EditInformation_editinfoBlock__4PGd8","editinfosTitle":"EditInformation_editinfosTitle__2PJfI"};